import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, Subject } from 'rxjs';
import { IdleStateEnum } from 'src/app/modules/core/dtos/idle-state.enum';
import { IdleDetectingService } from 'src/app/modules/core/services/idle-detecting.service';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { takeUntil } from 'rxjs/operators';

interface Carousel {
    image: string,
    name: string
};

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    public responsiveOptions: any;
    public products: Carousel[] = [];
    public displayText : string = '';
    private _unsubscribe$: Subject<void> = new Subject<void>();
    private _idleState$: Observable<IdleStateEnum> = new Subject<IdleStateEnum>();
    public text : string = 'User is not authorized to access ETAP';
    public constructor(public _authService: MsalService,
                      public _commonService: CommonService,
                      private idleDetectingService: IdleDetectingService) {
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }

    public ngOnInit(): void {
        this.products = [
            {
                image: 'NovAtelNews.png',
                name: 'NovAtelNews'
            },
            {
                image: 'Firmware.png',
                name: 'Firmware'
            },
            {
                image: 'info.png',
                name: 'info'
            },
            {
                image: 'TerraStar_CorrectionServicesAd.png',
                name: 'TerraStar_CorrectionServices'
            },
            {
                image: 'velocity.png',
                name: 'velocity'
            }
        ];
        // if (this._authService.instance.getAllAccounts().length === 0) {
        //     this.displayText = 'Please login to access ETAP Application';
        // }
        this._idleState$ = this.idleDetectingService.getIdleState();
        this._idleState$
            .pipe(takeUntil(this._unsubscribe$))
            .subscribe((state: IdleStateEnum): void => {
                if (state === IdleStateEnum.NOT_IDLE) {
                    this.text = '';
                }
            }
            );
    }

    public ngOnDestroy(): void {
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }
}
